import { PaginatedUserCollections } from './userCollection.gql';

export const QueryConfig = {
    query: PaginatedUserCollections,
    pathToItems: 'paginatedUserCollections',
    pathToTotalItems: 'totalRecords',
};
